export var Paths;

(function (Paths) {
  Paths["ListMissions"] = "/me/missions";
  Paths["ListBadges"] = "/me/badges";
  Paths["ListMilestones"] = "/progress/levels";
  Paths["ClaimMission"] = "/me/missions/:attemptId";
  Paths["AttemptMission"] = "/me/signals";
})(Paths || (Paths = {}));